import { c, classy, m } from '@onfido/castor';
import React, { useEffect, useMemo, useState } from 'react';
import { MaybeIcon } from '../../internal';
import { useForwardedRef, withRef } from '../../utils';
import { CustomSelect } from './custom';
import { NativeSelect } from './native';
import { SelectProvider } from './useSelect';
/**
 * `Select` by default uses two `Icon` that require `Icons` (SVG sprite) to be
 * included in your app.
 *
 * https://github.com/onfido/castor-icons#use-with-plain-code
 *
 * You may also provide any other SVG element via the `icon` and `selectedIcon`
 * props, but using Castor iconography is recommended.
 */
export const Select = withRef(function Select({ id: initialId, borderless, className, icon, native, onChange, ...restProps }, ref) {
    const { defaultValue, value } = restProps;
    const selectRef = useForwardedRef(ref);
    const [empty, setEmpty] = useState(!(value !== null && value !== void 0 ? value : defaultValue));
    const [open, setOpen] = useState(false);
    const id = useMemo(() => `castor_select_${++idCount}`, [initialId]);
    // on every re-render, check for "empty" just after a DOM cycle
    useEffect(() => void setTimeout(() => { var _a; return setEmpty(!((_a = selectRef.current) === null || _a === void 0 ? void 0 : _a.value)); }));
    useEffect(() => {
        if (value != null)
            setEmpty(!value);
    }, [value]);
    return (React.createElement("div", { className: classy(c('select'), m({ borderless, empty, open }), className) },
        React.createElement(SelectProvider, { value: { native } },
            React.createElement(Content, { ...restProps, ref: selectRef, id: id, borderless: borderless, native: native, open: open, onChange: (event) => {
                    setEmpty(!event.currentTarget.value);
                    onChange === null || onChange === void 0 ? void 0 : onChange(event);
                }, onOpenChange: setOpen }),
            React.createElement(MaybeIcon, { icon: icon, name: "chevron-down" }))));
});
const Content = withRef(function Content({ borderless, native, open, onOpenChange, ...restProps }, ref) {
    if (native)
        return React.createElement(NativeSelect, { ...restProps, ref: ref });
    return (React.createElement(CustomSelect, { ...restProps, ref: ref, borderless: borderless, open: open, onOpenChange: onOpenChange }));
});
let idCount = 0;
//# sourceMappingURL=select.js.map